import { render, staticRenderFns } from "./StudioProductGenre.vue?vue&type=template&id=0057fc39&scoped=true&"
import script from "./StudioProductGenre.vue?vue&type=script&lang=js&"
export * from "./StudioProductGenre.vue?vue&type=script&lang=js&"
import style0 from "./StudioProductGenre.vue?vue&type=style&index=0&id=0057fc39&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0057fc39",
  null
  
)

component.options.__file = "StudioProductGenre.vue"
export default component.exports